import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/factor-rules')({
  beforeLoad: () => getTitleContextSlice('Factor Rules'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
